<template>
  <link
    rel="stylesheet"
    href="https://cdn.jsdelivr.net/npm/@mdi/font@5.8.55/css/materialdesignicons.min.css"
  />
  <div class="app-container">
    <div class="app-body">
      <aside class="menu box sidebar" :class="{ 'is-collapsed': sidebarCollapsed }">
        <button
          class="sidebar-toggle"
          data-tour="sidebar-toggle"
          @click="sidebarCollapsed = !sidebarCollapsed"
        >
          <b-icon :icon="sidebarCollapsed ? 'chevron-right' : 'chevron-left'" />
        </button>
        <div class="sidebar-inner">
          <div v-if="true">
            <div v-if="!sidebarCollapsed" class="sidebar-header">
              <img :src="logo" alt="DigiDat" class="sidebar-brand-logo" />
            </div>
          </div>

          <div class="sidebar-scroll">
            <div class="sidebar-content">
              <p class="menu-label" style="display: none">{{ $t(`general.chapters`) }}</p>
              <ul class="menu-list" data-tour="chapter-nav">
                <li v-for="chapter in chapters" :key="chapter.id">
                  <a
                    href="#"
                    :class="{ 'is-active': activeChapter === chapter.id }"
                    @click.prevent="scrollTo(chapter.id)"
                  >
                    <b-icon
                      v-if="chapter.status"
                      :icon="chapter.icon!"
                      :type="chapter.type"
                      size="is-small"
                      class="chapter-status-icon"
                      :class="`chapter-status-${chapter.status}`"
                      :data-tour="chapter.id === 'chapter0' ? 'validation-icon' : undefined"
                    />
                    <span>{{ $t(`${chapter.id}.title`) }}</span>
                  </a>
                </li>
              </ul>
            </div>
          </div>

          <div v-if="!sidebarCollapsed" class="sidebar-footer">
            <div class="sidebar-logos">
              <a href="https://www.imi-frankfurt.de/" target="_blank" rel="noopener noreferrer">
                <img :src="logoImi" alt="IMI" class="sidebar-logo" />
              </a>
              <a href="https://www.unimedizin-ffm.de/" target="_blank" rel="noopener noreferrer">
                <img :src="logoUnimed" alt="Universitätsmedizin Frankfurt" class="sidebar-logo" />
              </a>
            </div>
            <div class="sidebar-legal-links">
              <a
                href="https://www.unimedizin-ffm.de/impressum"
                target="_blank"
                rel="noopener noreferrer"
                >{{ $t('general.impressum') }}</a
              >
              <a
                href="https://www.unimedizin-ffm.de/datenschutzerklaerung"
                target="_blank"
                rel="noopener noreferrer"
                >{{ $t('general.datenschutzerklaerung') }}</a
              >
            </div>
          </div>
        </div>
      </aside>

      <div class="content-column">
        <main class="content container is-fluid" ref="contentRef" @scroll="onScroll">
          <Disclaimer />

          <Chapter0
            id="chapter0"
            :key="`chapter0-${store.resetVersion}`"
            :modelValue="chapter0"
            @update:modelValue="chapter0 = $event"
          />

          <Chapter1
            id="chapter1"
            :key="`chapter1-${store.resetVersion}`"
            :modelValue="chapter1"
            @update:modelValue="chapter1 = $event"
          />

          <Chapter2
            id="chapter2"
            :key="`chapter2-${store.resetVersion}`"
            :modelValue="chapter2"
            @update:modelValue="chapter2 = $event"
          />

          <Chapter3
            id="chapter3"
            :key="`chapter3-${store.resetVersion}`"
            :modelValue="chapter3"
            @update:modelValue="chapter3 = $event"
          />

          <Chapter4
            id="chapter4"
            :key="`chapter4-${store.resetVersion}`"
            :modelValue="chapter4"
            @update:modelValue="chapter4 = $event"
          />

          <Chapter5
            id="chapter5"
            :key="`chapter5-${store.resetVersion}`"
            :modelValue="chapter5"
            @update:modelValue="chapter5 = $event"
          />

          <Chapter6
            id="chapter6"
            :key="`chapter6-${store.resetVersion}`"
            :modelValue="chapter6"
            @update:modelValue="chapter6 = $event"
          />

          <Chapter7
            id="chapter7"
            :key="`chapter7-${store.resetVersion}`"
            :modelValue="chapter7"
            @update:modelValue="chapter7 = $event"
          />

          <Chapter8
            id="chapter8"
            :key="`chapter8-${store.resetVersion}`"
            :modelValue="chapter8"
            @update:modelValue="chapter8 = $event"
          />

          <Chapter9
            id="chapter9"
            :key="`chapter9-${store.resetVersion}`"
            :modelValue="chapter9"
            @update:modelValue="chapter9 = $event"
          />

          <Chapter10
            id="chapter10"
            :key="`chapter10-${store.resetVersion}`"
            :modelValue="chapter10"
            @update:modelValue="chapter10 = $event"
          />

          <Chapter11 id="chapter11" :key="`chapter11-${store.resetVersion}`" />

          <div v-if="eastereggsEnabled" class="elevator-section">
            <button ref="elevatorButton" type="button" class="button elevator-button">
              <b-icon icon="elevator" />
              <span>{{ $t('general.backToTop') }}</span>
            </button>
          </div>
        </main>

        <footer class="app-footer">
          <div class="footer-icon-buttons">
            <div class="footer-settings">
              <b-tooltip :label="$t('general.settings')" type="is-info" append-to-body>
                <button
                  class="footer-settings-button"
                  data-tour="settings-button"
                  @click="settingsExpanded = !settingsExpanded"
                >
                  <b-icon icon="cog-outline" size="is-medium" />
                </button>
              </b-tooltip>

              <div v-if="settingsExpanded" class="footer-settings-panel">
                <b-field class="control-switch-field">
                  <b-switch v-model="isDark"> Dark mode </b-switch>
                </b-field>

                <b-field class="control-switch-field">
                  <b-switch v-model="showInfoGlobal">{{ $t('general.showInfo') }}</b-switch>
                </b-field>

                <b-field class="control-switch-field">
                  <b-switch v-model="showRechtstextGlobal">{{
                    $t('general.showRechtstext')
                  }}</b-switch>
                </b-field>

                <div v-if="languageSwitchEnabled" class="language-switch">
                  <img
                    :src="flagDe"
                    alt="Deutsch"
                    title="Deutsch"
                    class="language-flag"
                    :class="{ 'is-inactive': locale !== 'de' }"
                    @click="locale = 'de'"
                  />
                  <img
                    :src="flagEn"
                    alt="English"
                    title="English"
                    class="language-flag"
                    :class="{ 'is-inactive': locale !== 'en' }"
                    @click="confirmSwitchToEnglish"
                  />
                </div>

                <div class="settings-version">{{ $t('general.version') }} {{ appVersion }}</div>
              </div>
            </div>

            <b-tooltip
              v-if="guidedTourEnabled"
              :label="$t('general.tour.start')"
              type="is-info"
              append-to-body
            >
              <button class="footer-settings-button" @click="openTour">
                <b-icon icon="help-circle-outline" size="is-medium" />
              </button>
            </b-tooltip>

            <b-tooltip
              :label="$t('general.githubRepo')"
              position="is-top"
              type="is-dark"
              v-if="false"
            >
              <a
                class="footer-settings-button"
                :href="githubRepoUrl"
                target="_blank"
                rel="noopener"
              >
                <b-icon icon="github" size="is-medium" />
              </a>
            </b-tooltip>
          </div>

          <div class="footer-actions">
            <template v-if="!hideDraftControls">
              <b-button
                type="is-danger"
                icon-left="delete-outline"
                :loading="isSubmitting"
                :disabled="isSubmitting"
                @click="clearForm"
              >
                {{ $t(`general.clearForm`) }}
              </b-button>

              <b-upload
                v-model="file"
                accept=".pdf"
                :disabled="isSubmitting || loading"
                data-tour="import-button"
              >
                <a class="button" :class="{ 'is-loading': isSubmitting || loading }">
                  <b-icon icon="file-upload-outline" />
                  <span>{{ $t(`general.import`) }}</span>
                </a>
              </b-upload>

              <b-button
                type="is-link"
                icon-left="content-save-outline"
                :loading="isSubmitting"
                :disabled="isSubmitting"
                data-tour="export-draft-button"
                @click="handleSubmit(false, true)"
              >
                {{ $t(`general.export`) }}
              </b-button>
            </template>

            <b-button
              type="is-success"
              icon-left="file-pdf-box"
              :loading="isSubmitting"
              :disabled="isSubmitting"
              data-tour="download-pdf-button"
              @click="handleSubmit(false)"
            >
              {{ $t(`general.downloadPdf`) }}
            </b-button>
          </div>
        </footer>
      </div>
    </div>

    <b-modal
      :model-value="!!file"
      has-modal-card
      :can-cancel="loading ? [] : ['escape', 'x', 'outside']"
      @update:model-value="(active) => !active && clearFile()"
    >
      <div class="modal-card" style="width: 420px">
        <header class="modal-card-head">
          <p class="modal-card-title">{{ $t(`general.import`) }}</p>
        </header>
        <section class="modal-card-body">
          <b-icon icon="file-pdf-box" />
          {{ file?.name }}
        </section>
        <footer class="modal-card-foot">
          <b-button :disabled="loading" @click="clearFile">{{ $t(`general.cancel`) }}</b-button>
          <b-button
            type="is-link"
            icon-left="database-import-outline"
            :loading="loading"
            :disabled="loading"
            @click="processPdf(file!)"
          >
            Importieren
          </b-button>
        </footer>
      </div>
    </b-modal>
  </div>
</template>

<script setup lang="ts">
import { computed, nextTick, provide, ref, watch } from 'vue'
import { initAgent } from 'clippyjs'
import Clippy from 'clippyjs/agents/clippy'
import Elevator from 'elevator.js'
import { useStudyStore } from '@/stores/studyStore'
import { config } from '@/config'
import { useVisibilityMasterToggles } from '@/composables/useVisibilityToggles'
import { useGuidedTour } from '@/composables/useGuidedTour'
import {
  BButton,
  BField,
  BIcon,
  BModal,
  BSwitch,
  BTooltip,
  BUpload,
  useDialog,
  useToast,
} from 'buefy'
import { useI18n } from 'vue-i18n'
import * as pdfjsLib from 'pdfjs-dist'
import type { Study } from '@/types/studyTypes'
import type { ChapterErrors } from '@/validators/types.ts'
import Disclaimer from '@/components/Disclaimer.vue'
import Chapter0 from './components/Chapter0_PersonenFachklinikLaufzeit.vue'
import Chapter1 from './components/Chapter1_Studienparameter.vue'
import Chapter2 from './components/Chapter2_Datenbeschreibung.vue'
import Chapter3 from './components/Chapter3_Datenherkunft.vue'
import Chapter4 from './components/Chapter4_BetroffenePersonen.vue'
import Chapter5 from './components/Chapter5_Datenverarbeitung.vue'
import Chapter6 from './components/Chapter6_Datenspeicherung.vue'
import Chapter7 from './components/Chapter7_Datenweitergabe.vue'
import Chapter8 from './components/Chapter8_ArchivierungLoeschung.vue'
import Chapter9 from './components/Chapter9_VerantwortlicheUndDSB.vue'
import Chapter10 from './components/Chapter10_TOMs.vue'
import Chapter11 from './components/Chapter11_Rechtstexte.vue'
import flagDe from '@/assets/flag-de.svg'
import flagEn from '@/assets/flag-en.svg'
import elevatorMusic from '@/assets/elevator/elevator.mp3'
import elevatorDing from '@/assets/elevator/ding.mp3'

const { t, locale } = useI18n()
const dialog = useDialog()
const toast = useToast()
const store = useStudyStore()

// English translations (esp. legal texts) aren't proof-read yet, so switching
// to English needs an explicit confirmation; switching back to German doesn't.
function confirmSwitchToEnglish() {
  if (locale.value === 'en') return
  dialog.confirm({
    title: 'Warning',
    message:
      'This English version is AI-generated and unreviewed. In case of doubt, the German version prevails.',
    confirmText: 'Continue to English',
    cancelText: 'Cancel (back to German)',
    type: 'is-warning',
    hasIcon: true,
    onConfirm: () => {
      locale.value = 'en'
    },
  })
}

const contentRef = ref<HTMLElement | null>(null)
const elevatorButton = ref<HTMLButtonElement | null>(null)
const sidebarCollapsed = ref(false)
const settingsExpanded = ref(false)
const appVersion = __APP_VERSION__
const githubRepoUrl = 'https://github.com/imi-frankfurt/digidat-frontend'
const isSubmitting = ref(false)
const activeChapter = ref('chapter0')
const file = ref<File | null>(null)
const loading = ref(false)
const error = ref<string | null>(null)
const appliedFile = ref<string | null>(null)

const hideDraftControls = ref(!!config.HIDE_DRAFT_CONTROLS)
const languageSwitchEnabled = ref(!!config.LANGUAGE_SWITCH_ENABLED)
const eastereggsEnabled = ref(!!config.EASTEREGGS_ENABLED)
const guidedTourEnabled = ref(!!config.GUIDED_TOUR_ENABLED)

const { startTour } = useGuidedTour()

// Waits out the sidebar's collapse/expand CSS transition (see `.sidebar` below)
// so driver.js measures the fully expanded chapter nav, not the collapsed one.
const SIDEBAR_TRANSITION_MS = 300

async function openTour() {
  sidebarCollapsed.value = false
  settingsExpanded.value = false
  await nextTick()
  setTimeout(startTour, SIDEBAR_TRANSITION_MS)
}

const stored = localStorage.getItem('theme')
const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches
const isDark = ref(stored === 'dark' || (!stored && prefersDark))

const { showInfoGlobal, showRechtstextGlobal } = useVisibilityMasterToggles()

// Served from public/logos (mounted as a Docker volume in production), not bundled,
// so logos can be swapped without rebuilding the image. See docker/README for the mount.
const logo = computed(() => (isDark.value ? '/logos/logo_dark.svg' : '/logos/logo.svg'))
const logoImi = computed(() =>
  isDark.value ? '/logos/logo_imi_dark.svg' : '/logos/logo_imi_light.svg',
)
const logoUnimed = computed(() =>
  isDark.value ? '/logos/logo_unimed_dark.png' : '/logos/logo_unimed_light.svg',
)

// The scrollable area is the `.content` element, not window/body, so
// elevator.js's own (window-based) scrolling is a no-op here - drive the
// real scroll ourselves in parallel, using elevator.js's own easing/timing.
const ELEVATOR_DURATION = 20000

function easeInOutQuad(t: number, b: number, c: number, d: number) {
  t /= d / 2
  if (t < 1) return (c / 2) * t * t + b
  t--
  return (-c / 2) * (t * (t - 2) - 1) + b
}

function rideElevatorToTop() {
  const container = contentRef.value
  if (!container) return
  const startPosition = container.scrollTop
  const startTime = performance.now()

  function step(now: number) {
    const elapsed = Math.min(now - startTime, ELEVATOR_DURATION)
    container!.scrollTop = easeInOutQuad(elapsed, startPosition, -startPosition, ELEVATOR_DURATION)
    if (elapsed < ELEVATOR_DURATION) requestAnimationFrame(step)
  }

  requestAnimationFrame(step)
}

// Eastereggs are off by default and only wired up once config.json confirms
// EASTEREGGS_ENABLED - see the `fetch('/config.json')` call above.
let eastereggsInitialized = false

watch(
  eastereggsEnabled,
  async (enabled) => {
    if (!enabled || eastereggsInitialized) return
    eastereggsInitialized = true

    const clippy = await initAgent(Clippy)
    clippy.show(false)
    clippy.animate()
    clippy.moveTo(200, 800, 5000)
    clippy.gestureAt(250, 850)
    clippy.speak(
      'Hallo! Ist es nicht schön dass Sie Ihre Daten zu dem Projekt erneut irgendwo eintippen dürfen? Viel Spaß dabei!',
      false,
    )

    await nextTick()
    const elevator = new Elevator({
      mainAudio: elevatorMusic,
      endAudio: elevatorDing,
      duration: ELEVATOR_DURATION,
    })

    elevatorButton.value?.addEventListener('click', () => {
      elevator.elevate()
      rideElevatorToTop()
    })
  },
  { immediate: true },
)

const STUDY_CHAPTERS: (keyof Study)[] = [
  'personenFachklinikLaufzeit',
  'studienparameter',
  'datenbeschreibung',
  'datenherkunft',
  'betroffenePersonen',
  'datenverarbeitung',
  'datenspeicherung',
  'datenweitergabe',
  'archivierungLoeschungAnonymisierung',
  'verantwortlicheUndDsb',
  'TOMs',
]

// Chapter 11 (Rechtstexte) has no study data / validator, so it's the one
// entry with studyKey undefined and gets no validation indicator.
const CHAPTER_STATUS_ICON = {
  untouched: { icon: 'checkbox-blank-circle-outline', type: undefined as string | undefined },
  valid: { icon: 'check-circle', type: 'is-success' },
  invalid: { icon: 'close-circle', type: 'is-danger' },
} as const

const chapters = computed(() =>
  Array.from({ length: 12 }, (_, i) => {
    const studyKey = STUDY_CHAPTERS[i]
    const status = studyKey ? store.getChapterStatus(studyKey) : undefined
    const iconInfo = status ? CHAPTER_STATUS_ICON[status] : undefined
    return {
      id: `chapter${i}`,
      anchor: `chapter${i}`,
      status,
      icon: iconInfo?.icon,
      type: iconInfo?.type,
    }
  }),
)

const chapter0 = computed({
  get: () => store.study.personenFachklinikLaufzeit,
  set: (v: Study['personenFachklinikLaufzeit']) =>
    store.updateChapter('personenFachklinikLaufzeit', v),
})
const chapter1 = computed({
  get: () => store.study.studienparameter,
  set: (v: Study['studienparameter']) => store.updateChapter('studienparameter', v),
})
const chapter2 = computed({
  get: () => store.study.datenbeschreibung,
  set: (v: Study['datenbeschreibung']) => store.updateChapter('datenbeschreibung', v),
})
const chapter3 = computed({
  get: () => store.study.datenherkunft,
  set: (v: Study['datenherkunft']) => store.updateChapter('datenherkunft', v),
})
const chapter4 = computed({
  get: () => store.study.betroffenePersonen,
  set: (v: Study['betroffenePersonen']) => store.updateChapter('betroffenePersonen', v),
})
const chapter5 = computed({
  get: () => store.study.datenverarbeitung,
  set: (v: Study['datenverarbeitung']) => store.updateChapter('datenverarbeitung', v),
})
const chapter6 = computed({
  get: () => store.study.datenspeicherung,
  set: (v: Study['datenspeicherung']) => store.updateChapter('datenspeicherung', v),
})
const chapter7 = computed({
  get: () => store.study.datenweitergabe,
  set: (v: Study['datenweitergabe']) => store.updateChapter('datenweitergabe', v),
})
const chapter8 = computed({
  get: () => store.study.archivierungLoeschungAnonymisierung,
  set: (v: Study['archivierungLoeschungAnonymisierung']) =>
    store.updateChapter('archivierungLoeschungAnonymisierung', v),
})
const chapter9 = computed({
  get: () => store.study.verantwortlicheUndDsb,
  set: (v: Study['verantwortlicheUndDsb']) => store.updateChapter('verantwortlicheUndDsb', v),
})
const chapter10 = computed({
  get: () => store.study.TOMs,
  set: (v: Study['TOMs']) => store.updateChapter('TOMs', v),
})

const showManuelleFreigabe = computed(() => {
  const s = store.study

  return (
    s.personenFachklinikLaufzeit.ohneEnddatum ||
    s.studienparameter.studientypContainer.registerVerwendung === 'eigenesAufsetzen' ||
    (s.studienparameter.studientypContainer.studienzentren !== 'monozentrisch' &&
      (s.betroffenePersonen.erwarteteFaelleGesamt === undefined ||
        s.betroffenePersonen.erwarteteFaelleGesamt < 7)) ||
    s.datenverarbeitung.verarbeitungMitKi !== undefined ||
    (s.datenverarbeitung.diga !== undefined &&
      ((s.studienparameter.eigeninitiiert && !s.datenverarbeitung.diga.bfarmZulassung) ||
        (!s.studienparameter.eigeninitiiert &&
          !s.datenverarbeitung.diga.bfarmZulassung &&
          !s.datenverarbeitung.diga.durchSponsorVorgegeben))) ||
    s.datenverarbeitung.publikationPersonenbezogenerDaten === true
  )
})

async function submit(testdata: boolean, draft: boolean = false) {
  try {
    const result = testdata ? await store.submitTestdata() : await store.submitStudy(draft)

    if (!result.success) {
      if (result.reason === 'validation') {
        const errorLines = Object.values(result.errors as ChapterErrors)
          .flatMap((errs) => errs ?? [])
          .map((e) => `• ${e.message}`)
          .join('\n')
        dialog.alert({
          title: 'Pflichtfelder fehlen',
          message: `<div style="white-space: pre-line">${errorLines}</div>`,
          type: 'is-danger',
          hasIcon: true,
          icon: 'alert-circle',
        })
      } else if (result.reason === 'schema') {
        toast.open({
          message: 'Die Daten entsprechen nicht dem erwarteten Format.',
          type: 'is-danger',
          duration: 5000,
        })
      } else if (result.reason === 'rateLimited') {
        toast.open({
          message: 'Zu viele Anfragen. Bitte warten Sie einen Moment und versuchen Sie es erneut.',
          type: 'is-danger',
          duration: 5000,
        })
      } else {
        toast.open({
          message: 'Übermittlung fehlgeschlagen. Bitte versuchen Sie es erneut.',
          type: 'is-danger',
          duration: 5000,
        })
      }
    } else {
      toast.open({ message: 'PDF erfolgreich heruntergeladen', type: 'is-success', duration: 5000 })
    }
  } finally {
    isSubmitting.value = false
  }
}

function generateDialogText() {
  const items: string[] = []
  const study = store.study

  if (study.personenFachklinikLaufzeit.ohneEnddatum) items.push(t('chapter0.q4.ohne'))
  if (study.studienparameter.studientypContainer.registerVerwendung === 'eigenesAufsetzen')
    items.push(t('chapter1.q3a.eigenesAufsetzen'))
  if (
    study.studienparameter.studientypContainer.studienzentren !== 'monozentrisch' &&
    (study.betroffenePersonen.erwarteteFaelleGesamt === undefined ||
      study.betroffenePersonen.erwarteteFaelleGesamt < 7)
  )
    items.push(t('chapter4.q2.text-gesamt'))
  if (study.datenverarbeitung.verarbeitungMitKi !== undefined)
    items.push(t('chapter5.q1.textCheckbox'))
  if (study.datenverarbeitung.diga !== undefined) {
    if (
      (study.studienparameter.eigeninitiiert && !study.datenverarbeitung.diga.bfarmZulassung) ||
      (!study.studienparameter.eigeninitiiert &&
        !(
          study.datenverarbeitung.diga.bfarmZulassung ||
          study.datenverarbeitung.diga.durchSponsorVorgegeben
        ))
    ) {
      items.push(t('chapter5.q2.keinStandardprozess'))
    }
  }
  if (study.datenverarbeitung.publikationPersonenbezogenerDaten === true) {
    items.push(t('chapter5.q4.text'))
  }

  return `
    ${t('general.manuelleFreigabe')} <br />
    <ul style="list-style-type: square">
      ${items.map((e) => `<li>${e}</li>`).join('')}
    </ul>
  `
}

function submitWithDialog(testdata: boolean, draft: boolean = false) {
  dialog.confirm({
    title: 'Kein Standardprozess',
    message: generateDialogText(),
    confirmText: 'Herunterladen',
    cancelText: 'Abbrechen',
    type: 'is-danger',
    hasIcon: true,
    onConfirm: () => submit(testdata, draft),
    onCancel: () => {
      isSubmitting.value = false
    },
  })
}

function handleSubmit(testdata: boolean, draft: boolean = false) {
  if (isSubmitting.value) return
  isSubmitting.value = true
  if (showManuelleFreigabe.value) {
    submitWithDialog(testdata, draft)
  } else {
    submit(testdata, draft)
  }
}

function scrollTo(id: string) {
  const container = contentRef.value!
  const el = container.querySelector(`#${id}`) as HTMLElement
  if (!el) return
  container.scrollTo({ top: el.offsetTop, behavior: 'smooth' })
  activeChapter.value = id
}

provide('scrollToChapter', scrollTo)

function onScroll() {
  const container = contentRef.value!
  const scrollPosition = container.scrollTop
  for (let i = chapters.value.length - 1; i >= 0; i--) {
    const chapter = chapters.value[i]
    if (!chapter) continue
    const el = container.querySelector(`#${chapter.anchor}`) as HTMLElement
    if (!el) continue
    if (scrollPosition + 50 >= el.offsetTop) {
      activeChapter.value = chapter.id
      break
    }
  }
}

watch(isDark, (value) => {
  const theme = value ? 'dark' : 'light'

  localStorage.setItem('theme', theme)
  document.documentElement.setAttribute('data-theme', theme)
})

function clearFile() {
  file.value = null
  error.value = null
  appliedFile.value = null
}

async function processPdf(pdfFile: File) {
  loading.value = true
  error.value = null
  appliedFile.value = null

  try {
    const arrayBuffer = await pdfFile.arrayBuffer()
    const pdf = await pdfjsLib.getDocument({ data: arrayBuffer }).promise

    const attachments = await pdf.getAttachments()

    if (!attachments || attachments.size === 0) {
      throw new Error(
        'Keine Anhänge in dieser PDF-Datei gefunden. ' +
          'Bitte stellen Sie sicher, dass die Datei mit „qpdf --add-attachment" erstellt wurde.',
      )
    }

    const jsonEntry = [...attachments].find(([, att]) =>
      att.filename.toLowerCase().endsWith('.json'),
    )

    if (!jsonEntry) {
      throw new Error(
        'Kein JSON-Anhang gefunden. ' + 'Es wird eine eingebettete .json-Datei erwartet.',
      )
    }

    const [jsonId, jsonAttachment] = jsonEntry
    const jsonContent = jsonAttachment.content ?? (await pdf.getAttachmentContent(jsonId))

    if (!jsonContent) {
      throw new Error('Der JSON-Anhang enthält keine Daten.')
    }

    const jsonString = new TextDecoder('utf-8').decode(jsonContent)
    const parsed: Partial<Study> = JSON.parse(jsonString)

    store.resetStudy()
    applyToStore(parsed)
    appliedFile.value = pdfFile.name
    toast.open({ message: pdfFile.name + ' erfolgreich geladen!', type: 'is-success' })
  } catch (err: unknown) {
    if (err instanceof SyntaxError) {
      error.value = 'Der gefundene Anhang enthält kein gültiges JSON. Bitte prüfen Sie die Datei.'
    } else if (err instanceof Error) {
      error.value = err.message
    } else {
      error.value = 'Ein unerwarteter Fehler ist aufgetreten.'
    }
    toast.open({ duration: 5000, message: error.value!, type: 'is-danger' })
  } finally {
    loading.value = false
    clearFile()
  }
}

function applyToStore(data: Partial<Study>) {
  for (const chapter of STUDY_CHAPTERS) {
    if (data[chapter] !== undefined) {
      store.updateChapter(chapter, {
        ...store.study[chapter],
        ...(data[chapter] as Study[typeof chapter]),
      })
    }
  }
}

function clearForm() {
  dialog.confirm({
    title: 'Eingaben löschen',
    message: 'Alle Eingaben werden zurückgesetzt. Sind Sie sicher?',
    confirmText: 'Löschen',
    cancelText: 'Abbrechen',
    type: 'is-danger',
    hasIcon: true,
    onConfirm: () => store.resetStudy(),
  })
}
</script>

<style>
.app-container {
  display: flex;
  flex-direction: column;
  height: 100vh;
  overflow: hidden;
}

.app-body {
  flex: 1;
  min-height: 0;
  display: flex;
  overflow: hidden;
}

.content-column {
  flex: 1;
  min-width: 0;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.content {
  flex: 1;
  min-height: 0;
  padding: 0 2rem;
  overflow-y: auto;
}

.b-checkbox.checkbox,
.b-radio.radio {
  align-items: flex-start;
}

.b-checkbox.checkbox .check,
.b-radio.radio .check {
  margin-top: 3px;
  flex-shrink: 0;
}

fieldset div + div .b-checkbox.checkbox,
fieldset div + div .b-radio.radio,
.b-checkbox.checkbox + .b-checkbox.checkbox,
.b-radio.radio + .b-radio.radio {
  margin-top: 0;
  padding-top: 0.6rem;
}

.sidebar {
  width: 420px;
  min-width: 420px;
  height: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
  transition:
    width 0.3s ease,
    min-width 0.3s ease;
  overflow: visible;
}

.sidebar.is-collapsed {
  width: 40px;
  min-width: 40px;
}

.sidebar.is-collapsed .sidebar-content {
  display: none;
}

.sidebar-inner {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.sidebar-header {
  flex-shrink: 0;
  padding: 1rem 1rem 0.75rem;
  border-bottom: 1px solid var(--bulma-border-weak);
  margin-bottom: 0.5rem;
}

.sidebar-brand-logo {
  display: block;
  max-width: 100%;
  height: 120px;
  width: auto;
}

.sidebar-scroll {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
}

/* Lighter scrollspy indicator: a small caret instead of a solid block. */
.sidebar .menu-list a {
  position: relative;
  background-color: transparent;
  padding-left: 1.25em;
  display: flex;
  align-items: center;
  gap: 0.4em;
  transition: color 0.15s ease;
}

.sidebar .menu-list a:hover {
  background-color: hsla(var(--bulma-link-h), var(--bulma-link-s), var(--bulma-link-l), 0.08);
}

.sidebar .menu-list a.is-active {
  color: var(--bulma-link);
  font-weight: 600;
}

.sidebar .menu-list a.is-active::before {
  content: '';
  position: absolute;
  left: 0.15em;
  top: 50%;
  width: 0;
  height: 0;
  transform: translateY(-50%);
  border-top: 5px solid transparent;
  border-bottom: 5px solid transparent;
  border-left: 6px solid var(--bulma-link);
}

.chapter-status-icon {
  flex-shrink: 0;
}

.chapter-status-icon.chapter-status-untouched {
  color: var(--bulma-text-weak);
  opacity: 0.6;
}

.sidebar-toggle {
  position: absolute;
  top: 0.5rem;
  right: -16px;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border: 1px solid #dbdbdb;
  background: white;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.sidebar-toggle:hover {
  background: #f5f5f5;
}

.sidebar-footer {
  flex-shrink: 0;
  border-top: 1px solid var(--bulma-border-weak);
  padding-top: 1rem;
  margin-top: 0.5rem;
}

.control-switch-field {
  margin-bottom: 0;
}

.language-switch {
  display: flex;
  gap: 0.5rem;
  margin-top: 0.2rem;
}

.language-flag {
  width: 32px;
  height: auto;
  border-radius: 3px;
  cursor: pointer;
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.2);
  transition:
    filter 0.15s ease,
    opacity 0.15s ease;
}

.language-flag.is-inactive {
  filter: grayscale(1);
  opacity: 0.4;
}

.language-flag:hover.is-inactive {
  opacity: 0.7;
}

.settings-version {
  font-size: 0.8rem;
  color: var(--bulma-text-weak);
}

.sidebar-logos {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1.5rem;
  flex-shrink: 0;
}

.sidebar-logos a {
  display: contents;
}

.sidebar-logo {
  max-width: none;
  max-height: 56px;
  width: auto;
  height: auto;
  flex-shrink: 0;
}

.sidebar-legal-links {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 0.25rem 0.75rem;
  margin-top: 0.75rem;
  font-size: 0.75rem;
}

.sidebar-legal-links a {
  color: var(--bulma-text-weak);
}

.sidebar-legal-links a:hover {
  color: var(--bulma-text);
  text-decoration: underline;
}

.app-footer {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  padding: 0.75rem 1.5rem;
  border-top: 1px solid var(--bulma-border-weak);
}

.footer-icon-buttons {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex-shrink: 0;
}

.footer-actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  gap: 0.75rem;
}

.footer-settings {
  position: relative;
  flex-shrink: 0;
}

.footer-settings-button {
  flex-shrink: 0;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: 1px solid #dbdbdb;
  background: transparent;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: inherit;
  text-decoration: none;
}

.footer-settings-button:hover {
  background: hsla(var(--bulma-link-h), var(--bulma-link-s), var(--bulma-link-l), 0.08);
}

.footer-settings-panel {
  position: absolute;
  bottom: calc(100% + 0.75rem);
  left: 0;
  z-index: 20;
  min-width: 280px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.6rem;
  padding: 1rem;
  border-radius: 6px;
  background: var(--bulma-scheme-main);
  border: 1px solid var(--bulma-border-weak);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.elevator-section {
  display: flex;
  justify-content: center;
  margin: 2rem 0 3rem;
}

.elevator-button {
  gap: 0.5rem;
}
</style>
